<template>
  <div class="decks-page-component">
    <img
      :src="displayAttachment && displayAttachment.largeThumbnail"
      alt=""
    />
    <div
      class="list-page-header"
    >
      {{ deck && deck.assetTitle }}
    </div>
    <template v-if="isSeries">
      <button
        v-if="deckStateStatus === states.NOT_STARTED"
        class="series-button"
        data-test="begin-button"
        @click="$emit('begin-series')"
      >
        Begin
      </button>
      <button
        v-if="deckStateStatus === states.IN_PROGRESS"
        class="series-button"
        data-test="continue-button"
        @click="$emit('continue-series')"
      >
        Continue
      </button>
      <button
        v-if="deckStateStatus !== states.NOT_STARTED"
        class="series-button reset-button"
        data-test="reset-button"
        @click="$emit('restart-series')"
      >
        Restart Series
      </button>
    </template>
    <hlt-text
      v-if="deck.displayDescription"
      class="deck-page-description"
    >
      {{ deck.displayDescription }}
    </hlt-text>
    <div class="list-container">
      <deck-asset-row
        v-for="card in cards"
        :key="card.id"
        :asset="cardAsset(card)"
        :card="card"
        :deck="deck"
        @card-row-clicked="$emit('card-row-clicked', card)"
      />
    </div>
    <content-source-preview :content-source="contentSource" />
  </div>
</template>

<script>
import ContentSourcePreview from '@/components/content-sources/preview.vue';
import DeckAssetRow from '@/components/decks/assetRow.vue';
import HltText from '@/components/ui/text.vue';

import CardMixin from '@/mixins/card';

const STATES = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
};

export default {
  components: { ContentSourcePreview, DeckAssetRow, HltText },
  mixins: [CardMixin],
  props: {
    deck: {
      type: Object,
    },
  },
  emits: ['begin-series', 'continue-series', 'restart-series', 'card-row-clicked'],
  data() {
    return {
      states: STATES,
    };
  },
  computed: {
    cards() {
      if (this.deck) {
        return [...this.deck.cards].sort((a, b) => a.order - b.order);
      } else {
        return [];
      }
    },
    contentSource() {
      if (this.deck?.contentSourceId) {
        return this.$store.getters['contentSources/get'][this.deck.contentSourceId];
      }
    },
    displayAttachment() {
      if (this.deck?.displayAttachmentId) {
        return this.$store.getters['attachments/get'][this.deck.displayAttachmentId];
      }
    },
    deckStateStatus() {
      if (this.deck && this.cards) {
        let inProgress;
        const completedCards = this.cards.filter(card => {
          const asset = this.cardAsset(card);
          let state;
          if (!asset || asset.assetType === 'Deck') {
            return;
          }
          if (asset.assetType === 'Grouping') {
            state = asset.states(this.$store);
          } else {
            state = asset.state(this.$store);
          }
          if (asset.assetType === 'Attachment') {
            const isComplete = asset.completedState(state);
            if (!isComplete && state?.currentTimestamp > 0) {
              inProgress = true;
            }
            return isComplete;
          } else {
            return asset.completedState(state);
          }
        });
        if (completedCards.length === 0 && !inProgress) {
          return STATES.NOT_STARTED;
        } else if (completedCards.length === this.cards.length && !inProgress) {
          return STATES.COMPLETED;
        } else {
          return STATES.IN_PROGRESS;
        }
      }
    },
    isSeries() {
      if (this.deck) {
        return (this.deck?.deckType === 'Episodes');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.decks-page-component {
  width: 100%;

  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    border-radius: 4px;
  }

  .deck-page-description {
    margin: 1.5rem 0;
  }

  .series-button {
    align-items: center;
    border-radius: 4px;
    background-color: #00B46D;
    border: 0;
    color: #ffffff;
    display: flex;
    font-weight: $semi-bold;
    height: rem-calc(40);
    justify-content: center;
    padding: 0;
    width: 100%;
    margin: 1rem 0 .5rem 0;
  }

  .reset-button {
    margin: 0;
    border: 1px solid #000000;
    background-color: transparent;
    color: #000000;
  }

  @include breakpoint(small) {
    margin: 0 auto;
  }
}
</style>
